import React, { useState } from "react";
import styles from "./ReferStatus.module.scss";
import { ButtonGroup, Button, VStack, HStack, IconButton, Drawer, Placeholder } from "rsuite";
import { FaWhatsapp } from "react-icons/fa";
import { IoCallOutline } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import ReferStatusDrawer from "./ReferStatusDrawer";

export default function ReferStatus() {
  const [activeKey, setActiveKey] = useState("Pending Status");
  const [open, setOpen] = useState(false);

  return (
    <div className={styles["refer__status"]}>
      <ButtonGroup>
        {["Pending Status", "Complete Status"].map((key) => (
          <Button key={key} active={key === activeKey} onClick={() => setActiveKey(key)} size="md">
            {key}
          </Button>
        ))}
      </ButtonGroup>

      <br clear="all" />

      {activeKey === "Pending Status" ? (
        <div className={styles.list}>
          <VStack alignItems="stretch" spacing={5} onClick={() => setOpen(true)}>
            <HStack justifyContent="space-between" alignItems="center">
              <h6>9030137623</h6>
              <div>
                <IconButton icon={<FaWhatsapp size={30} color="#585858" />} appearance="link" />
                <IconButton icon={<IoCallOutline size={28} color="#585858" />} appearance="link" />
              </div>
            </HStack>
            <HStack justifyContent="space-between">
              <div>
                <p>
                  Get <strong>3%</strong> on your friend's Loan
                </p>
                <p>
                  Status: <strong>KYC Pending</strong>
                </p>
              </div>
              <IoIosArrowForward size={20} color="#585858" />
            </HStack>
          </VStack>
        </div>
      ) : (
        <div style={{ paddingTop: 14 }}>
          <div className={styles.list}>
            <VStack alignItems="stretch" spacing={5} onClick={() => setOpen(true)}>
              <HStack justifyContent="space-between" alignItems="center">
                <h6>9030137623</h6>
                <div>
                  <p className={styles.earned}>₹800 Earned</p>
                </div>
              </HStack>
            </VStack>
          </div>

          <div className={styles.list}>
            <VStack alignItems="stretch" spacing={5} onClick={() => setOpen(true)}>
              <HStack justifyContent="space-between" alignItems="center">
                <h6>9030137623</h6>
                <div>
                  <p className={styles.earned}>₹800 Earned</p>
                </div>
              </HStack>
            </VStack>
          </div>
        </div>
      )}

      {/* Refer Status Drawer */}
      <ReferStatusDrawer open={open} setOpen={setOpen} />
    </div>
  );
}
